import { useState } from "react";
import { Calendar, X } from "lucide-react";

const DatePicker = ({ onApply }) => {
  const [dates, setDates] = useState({ fromDate: "", toDate: "" });
  const [open, setOpen] = useState(false);

  const today = new Date().toISOString().split("T")[0];

  const handleFromDateChange = (e) => {
    const newFromDate = e.target.value;
    setDates((prev) => ({
      ...prev,
      fromDate: newFromDate,
      toDate: prev.toDate && prev.toDate < newFromDate ? "" : prev.toDate,
    }));
  };

  const handleToDateChange = (e) => {
    setDates((prev) => ({ ...prev, toDate: e.target.value }));
  };

  const handleApply = () => {
    if (onApply) {
      onApply(dates); // pass up to parent
    }
    setOpen(false);
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100"
      >
        <Calendar className="w-5 h-5 text-gray-600" />
      </button>
    );
  }

  return (
    <div className="absolute z-[9999] top-20 left-1/2 -translate-x-1/2 bg-white border border-gray-300 rounded-xl shadow-xl w-80 p-5">
      {/* Header with cross button */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-base font-semibold text-gray-800">Select Date Range</h3>
        <button
          onClick={() => setOpen(false)}
          className="p-1 rounded-full hover:bg-gray-100"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>
      </div>

     {/* From Date */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">From</label>
        <input
          type="date"
          value={dates.fromDate}
          onChange={handleFromDateChange}
          onKeyDown={(e) => e.key === "Enter" && dates.fromDate && dates.toDate && handleApply()}
          max={today}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* To Date */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">To</label>
        <input
          type="date"
          value={dates.toDate}
          onChange={handleToDateChange}
          onKeyDown={(e) => e.key === "Enter" && dates.fromDate && dates.toDate && handleApply()}
          min={dates.fromDate || undefined}
          max={today}
          disabled={!dates.fromDate}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
        />
        {!dates.fromDate && (
          <p className="text-xs text-gray-500 mt-1">Select a start date first</p>
        )}
      </div>


      {/* Actions */}
      <div className="flex justify-end gap-2">
        <button
          onClick={() => setDates({ fromDate: "", toDate: "" })}
          className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Clear
        </button>
        <button
        type="submit"
          disabled={!dates.fromDate || !dates.toDate}
          onClick={handleApply}
          className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-300"
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default DatePicker;
